module.exports = __webpack_public_path__ + "img/图像 11@2x.b27ba2c5.webp";